var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"href":_vm.menu.route}},[_c('v-list-item-icon',[(_vm.menu.icon)?_c('v-icon',{domProps:{"textContent":_vm._s(_vm.menu.icon)}}):_vm._e()],1),_vm._v(" "),_c('v-list-item-title',{domProps:{"textContent":_vm._s(_vm.menu.name)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }